export default __webpack_public_path__ + "static/Dekra_LP2_iPhoneSmall-f310e24dea420ab8b2ebbcdcc71d8e0a.png";